import React, { PropsWithChildren } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setActiveMenuItem } from "../../../redux/actions/menu/menu";
import { RESET_UPDATE_CAMPAIGN_STATUS } from "../../../redux/actionTypes/actionsTypes";
import { initialMenuItem } from "../../../redux/reducers/getMenu/getMenuReducer";
import {
    selectAuthValidateExternalToken,
    selectAuthValidateRefreshToken,
    selectMenu
} from "../../../redux/selectors/exportSelectorPaths";
import reportMenuDuration from "../../../utils/GA4EventHelpers/reportMenuDuration";

interface HomeProps extends PropsWithChildren {
    preToHomeFn?: () => void
    postToHomeFn?: () => void
}

export default function ToHome(props: HomeProps): JSX.Element {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const menuState = useSelector(selectMenu);
    const validateTokenStore = useSelector(selectAuthValidateExternalToken);
    const refreshTokenStore = useSelector(selectAuthValidateRefreshToken);

    const toHome = () => {
        reportMenuDuration(menuState, "Home");
        dispatch({ type: RESET_UPDATE_CAMPAIGN_STATUS })
        dispatch(setActiveMenuItem(initialMenuItem));

        const keepKeys = ["rollNumber", "wac", "commericalWizard", "multiresWizard", "isInternalUser"]
        Object.keys(sessionStorage).forEach(key => {
            if (!keepKeys.includes(key)) {
                sessionStorage.removeItem(key)
            }
        })

        if (!localStorage.getItem("authToken")) {
            if (validateTokenStore && validateTokenStore.valid) {
                validateTokenStore.token && localStorage.setItem("authToken", validateTokenStore.token);
                validateTokenStore.exp && localStorage.setItem("sessionExp", String(validateTokenStore.exp));
                validateTokenStore.validationToken && localStorage.setItem("validationToken", validateTokenStore.validationToken);
                validateTokenStore.refresh && localStorage.setItem("refreshToken", validateTokenStore.refresh);
            }
            if (refreshTokenStore && refreshTokenStore.valid) {
                refreshTokenStore.token && localStorage.setItem("authToken", refreshTokenStore.token);
                refreshTokenStore.exp && localStorage.setItem("sessionExp", String(refreshTokenStore.exp));
                refreshTokenStore.validationToken && localStorage.setItem("validationToken", refreshTokenStore.validationToken);
                refreshTokenStore.refresh && localStorage.setItem("refreshToken", refreshTokenStore.refresh);
            }
        }

        if (sessionStorage.getItem("isInternalUser")) {
            navigate("/internal-landing")
        } else {
            navigate('/landing')
        }
    }

    return (
        <div onClick={() => {
            if (props.preToHomeFn) {
                props.preToHomeFn()
            }
            toHome()
            if (props.postToHomeFn) {
                props.postToHomeFn()
            }
        }}>
            {props.children}
        </div>
    )
}
